export default "__VITE_ASSET___enaQVfx__"